import { SelectItem } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { OnBoardingUploadType, OnBoardingUserModel } from 'src/app/models/onBoardingModels';
import { loadManageOnboardingUserInfo, loadOnboardingUploadTypes, saveUserProfile, saveUserProfileFailure, saveUserProfileSuccess, updateUserProfileForm, uploadEVerifyDocument, uploadEVerifyDocumentFailure, uploadEVerifyDocumentSuccess } from './../../../../core/store/onboarding/onboarding.actions';
import { updateProfileForm, loadRaceOptions, loadProfileOptions, saveProfileSuccess, loadProfile, loadSpokenLanguageOptions } from './../../../../core/store/profile/profile.actions';
import { UserProfileModel } from './../../../../models/userProfileModel';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { saveProfile } from '../../../../core/store/profile/profile.actions';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { createBCIResidenceFormGroup, initProfileForm } from 'src/app/core/store/profile/profile.reducer';
import { getAllControlsErrors, markFormGroupTouched } from 'src/app/helpers/utils';
import { BaseComponent } from 'src/app/core/abstracts/baseComponent';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { AlertService } from 'src/app/shared/services/alert.service';
@Component({
    selector: 'app-contact-info',
    templateUrl: './contact-info.component.html',
    styleUrls: ['./contact-info.component.scss'],
    standalone: false
})
export class ContactInfoComponent extends BaseComponent implements OnInit {
  @ViewChild('profileUsersWhy') profileUsersWhy: ElementRef;
  profile: UserProfileModel;
  form: UntypedFormGroup;
  hasOnBoardingPermission: boolean;
  savingProfile: boolean;
  @Input() managedUserId;
  @Input() readOnly = false;
  manageOnboardingUserInfo: OnBoardingUserModel;
  paylocityEnabled: boolean = false;
  uploadTypes: OnBoardingUploadType[] = [];
  eVerifyDocumentFiles: File[] = [];
  pendingEVerifyDocumentFiles: File[] = [];
  uploadingEVerifyDocument = false;

  maritalStatusOptions: SelectItem[] = [
    { label: 'I have a disability (or previouslyhad a disability)', value: 1 },];
  statutoryClassOptions: SelectItem[] = [
    { label: 'I have a disability (or previouslyhad a disability)', value: 1 },];
  eeoJobCategoryOptions: SelectItem[] = [
    { label: 'I have a disability (or previouslyhad a disability)', value: 1 },];
  acaClassificationOptions: SelectItem[] = [
    { label: 'I have a disability (or previouslyhad a disability)', value: 1 },];

  disabilityOptions: SelectItem[] = [
    { label: 'I have a disability (or previously had a disability)', value: 1 },
    { label: 'I do NOT have a disability', value: 0 },
    { label: 'I decline to state my disability status', value: 2 }];

  veteranOptions: SelectItem[] = [
    { label: 'I am a veteran', value: 1 },
    { label: 'I am NOT a veteran', value: 0 },
    { label: 'I decline to state my veteran status', value: 2 }];

  raceOptions: SelectItem[] = [
    { label: 'loading...', value: null }];

  spokenLanguageOptions: SelectItem[] = [
    { label: 'loading...', value: null }];

  genderOptions: SelectItem[] = [
    { label: 'Male', value: 1 },
    { label: 'Female', value: 0 }];

  yesNoOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  backTo: string;

  constructor(
    private actions$: Actions,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<State>,
    private fb: UntypedFormBuilder,
    private alertService: AlertService) {
    super();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(queryParams => {
      this.backTo = '';
      if (queryParams.backTo) {
        this.backTo = queryParams.backTo;
      }
    });
    this.subs.push(
      this.store.select(s => s.accountState.featureSwitchesIds).subscribe(featureSwitchesIds => {
        this.paylocityEnabled = featureSwitchesIds && !!featureSwitchesIds.find(p => p === 85);       
      }),
    );
    if (this.managedUserId) {
      //this.readOnly = true;
      this.subs.push(
        this.store.select(s => s.onboardingState.manageOnboardingUserInfo).subscribe(manageOnboardingUserInfo => {
          if (manageOnboardingUserInfo) {
            this.profile = manageOnboardingUserInfo.user;
            this.manageOnboardingUserInfo = manageOnboardingUserInfo;
            if (!this.form) {
              this.form = initProfileForm(this.profile, this.fb);
              this.subs.push(
                this.form.valueChanges.subscribe(formValues => {
                  const userValues = this.form.get('user').value;
                  const employeeValues = this.form.get('employee').value;
                  const formErrors = getAllControlsErrors(this.form);
                  this.store.dispatch(updateUserProfileForm({ userValues, employeeValues, formErrors }));
                })
              );
            }
          }
        }),        
      );

      this.store.dispatch(loadManageOnboardingUserInfo({ userId: this.managedUserId }));
      this.store.dispatch(loadOnboardingUploadTypes());
    } else {
      this.subs.push(
        this.store.select(s => s.profileState).subscribe(profileState => {
          this.profile = JSON.parse(JSON.stringify(profileState.profile));
          if (!this.form) {
            this.form = initProfileForm(this.profile, this.fb);
            this.subs.push(
              this.form.valueChanges.subscribe(formValues => {
                const userValues = this.form.get('user').value;
                const employeeValues = this.form.get('employee').value;
                const formErrors = getAllControlsErrors(this.form);
                this.store.dispatch(updateProfileForm({ userValues, employeeValues, formErrors }));
              })
            );
          }
        }),

        this.store.select(s => s.profileState.savingProfile).subscribe(savingProfile => {
          this.savingProfile = savingProfile;
        })
      );
      this.store.dispatch(loadProfile());
    }
    this.subs.push(
      this.store.select(s => s.profileState.raceOptions).subscribe(raceOptions => {
        const raceOptionsMapped = raceOptions && raceOptions.length > 0 ? raceOptions.map(c => ({ label: c.label, value: c.id }))
          : [{ label: 'loading...', value: undefined }];

        this.raceOptions = raceOptionsMapped;

      }),

      this.store.select(s => s.onboardingState.uploadTypes).subscribe(uploadTypes => {
        this.uploadTypes = uploadTypes ?? [];
      }),

      this.store.select(s => s.profileState.spokenLanguageOptions).subscribe(options => {
        const optionsMapped = options && options.length > 0 ? options.map(c => ({ label: c.language, value: c.id }))
          : [{ label: 'loading...', value: undefined }];

        this.spokenLanguageOptions = optionsMapped;

      }),

      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.hasOnBoardingPermission = permissionIDs && !!permissionIDs.find(p => p === 3060 //manage on board
        );
      }),

      this.store.select(s => s.profileState.maritalStatusOptions).subscribe(maritalStatusOptions => {
        const maritalStatusOptionsMapped = maritalStatusOptions && maritalStatusOptions.length > 0 ? maritalStatusOptions.map(c => ({ label: c.maritalStatus, value: c.id }))
          : [{ label: 'loading...', value: undefined }];
        this.maritalStatusOptions = maritalStatusOptionsMapped;
      }),
      this.store.select(s => s.profileState.statutoryClassOptions).subscribe(statutoryClassOptions => {
        const statutoryClassOptionsMapped = statutoryClassOptions && statutoryClassOptions.length > 0 ? statutoryClassOptions.map(c => ({ label: c.statutoryClass, value: c.id }))
          : [{ label: 'loading...', value: undefined }];
        this.statutoryClassOptions = statutoryClassOptionsMapped;
      }),
      this.store.select(s => s.profileState.eeoJobCategoryOptions).subscribe(eeoJobCategoryOptions => {
        const eeoJobCategoryOptionsMapped = eeoJobCategoryOptions && eeoJobCategoryOptions.length > 0 ? eeoJobCategoryOptions.map(c => ({ label: c.eeoJobCategory, value: c.id }))
          : [{ label: 'loading...', value: undefined }];
        this.eeoJobCategoryOptions = eeoJobCategoryOptionsMapped;
      }),
      this.store.select(s => s.profileState.acaClassificationOptions).subscribe(acaClassificationOptions => {
        const acaClassificationOptionsMapped = acaClassificationOptions && acaClassificationOptions.length > 0 ? acaClassificationOptions.map(c => ({ label: c.acaClassification, value: c.id }))
          : [{ label: 'loading...', value: undefined }];
        this.acaClassificationOptions = acaClassificationOptionsMapped;
      }),


      this.actions$.pipe(
        ofType(saveProfileSuccess),
        tap(action => {
          if (!this.managedUserId
            && Number(action.profile.userId) === Number(this.form.get('userId').value)
            && action.profile.employee.bciLivedOutside !== true
            && this.form.get('employee.bciLivedOutside').value !== true) {
            const residences = this.form.get('employee.bciResidences') as UntypedFormArray;
            residences.clear({ emitEvent: false });
            residences.disable({ emitEvent: false });
            this.form.get('employee').updateValueAndValidity({ emitEvent: false });
          }
          if (this.backTo) {
            this.router.navigate([this.backTo]);
          }
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(saveUserProfileSuccess),
        tap(action => {
          if (this.managedUserId && Number(action.userId) === Number(this.managedUserId)) {
            if (action.profile.employee.bciLivedOutside !== true
              && this.form.get('employee.bciLivedOutside').value !== true) {
              const residences = this.form.get('employee.bciResidences') as UntypedFormArray;
              residences.clear({ emitEvent: false });
              residences.disable({ emitEvent: false });
              this.form.get('employee').updateValueAndValidity({ emitEvent: false });
            }
            if (this.pendingEVerifyDocumentFiles.length) {
              this.uploadSelectedEVerifyDocument(this.pendingEVerifyDocumentFiles);
              this.pendingEVerifyDocumentFiles = [];
            }
          }
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(saveUserProfileFailure),
        tap(action => {
          this.pendingEVerifyDocumentFiles = [];
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(uploadEVerifyDocumentSuccess),
        tap(action => {
          if (this.managedUserId && Number(action.userId) === Number(this.managedUserId) && this.uploadingEVerifyDocument) {
            this.uploadingEVerifyDocument = false;
            this.eVerifyDocumentFiles = [];
            this.alertService.success('E-Verify document uploaded.');
            this.store.dispatch(loadManageOnboardingUserInfo({ userId: this.managedUserId }));
          }
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(uploadEVerifyDocumentFailure),
        tap(action => {
          this.uploadingEVerifyDocument = false;
        })
      ).subscribe(),
    );

    this.store.dispatch(loadRaceOptions());
    this.store.dispatch(loadProfileOptions());
    this.store.dispatch(loadSpokenLanguageOptions());
  }

  get differentGenderIdentity() {
    return this.form.get('employee.differentGenderIdentity').value;
  }

  save() {
    if (this.form.valid) {  
      if (this.managedUserId) {
        if (this.eVerifyDocumentFiles.length && !this.otherUploadType?.id) {
          this.alertService.error('Unable to upload the E-Verify document because the Other document type is not available.');
          return;
        }

        this.pendingEVerifyDocumentFiles = Object.assign([], this.eVerifyDocumentFiles);
        this.store.dispatch(saveUserProfile({ userId: this.managedUserId, profile: this.form.value as UserProfileModel }));
      } else {
        this.store.dispatch(saveProfile({ profile: this.form.value as UserProfileModel }));
      }
    } else {
      markFormGroupTouched(this.form);
    }
  }
  
  onInput(e) {
    const tx = this.profileUsersWhy.nativeElement;
    for (let i = 0; i < tx.length; i++) {
      tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight) + "px;overflow-y:hidden;");
    }
    e.target.style.height = 0;
    e.target.style.height = (e.target.scrollHeight) + "px";
  }

  copyFromHomeAddress() {
    this.form.get('employee.mailingAddress').setValue(this.form.get('employee.address').value);
    this.form.get('employee.mailingAddressExtra').setValue(this.form.get('employee.addressExtra').value);
    this.form.get('employee.mailingCity').setValue(this.form.get('employee.city').value);
    this.form.get('employee.mailingState').setValue(this.form.get('employee.state').value);
    this.form.get('employee.mailingZipCode').setValue(this.form.get('employee.zipCode').value);
    this.form.get('employee.mailingCounty').setValue(this.form.get('employee.county').value);
    this.form.get('employee.mailingCountry').setValue(this.form.get('employee.country').value);
  }

  addOtherLanguage() {
    (this.form.get('otherLanguages') as UntypedFormArray).push(this.fb.group({
      id: this.fb.control(0),
      spokenLanguageId: this.fb.control(0),
      moreInfo: this.fb.control("")
    }));
    return false;
  }

  removeLanguage(index) {
    let otherLanguages = this.form.get('otherLanguages') as UntypedFormArray;
    otherLanguages.removeAt(index);
    return false;    
  }

  getOtherLanguages() {
    return (this.form.get('otherLanguages') as UntypedFormArray).controls;
  }

  addBciResidence() {
    (this.form.get('employee.bciResidences') as UntypedFormArray).push(createBCIResidenceFormGroup());
    this.form.get('employee').updateValueAndValidity();
    return false;
  }

  removeBciResidence(index: number) {
    (this.form.get('employee.bciResidences') as UntypedFormArray).removeAt(index);
    this.form.get('employee').updateValueAndValidity();
    return false;
  }

  getBciResidences() {
    return (this.form.get('employee.bciResidences') as UntypedFormArray).controls;
  }

  get otherUploadType() {
    return this.uploadTypes?.find(uploadType => uploadType.docType === 'Other');
  }

  changeEVerifyDocumentFiles(fileInput: HTMLInputElement) {
    const files = Array.from(fileInput.files || []);
    if (this.hasUnsupportedWordDocument(files)) {
      this.alertService.error('Word documents are not allowed. Please upload a supported file such as PDF, JPG, or PNG.');
      fileInput.value = '';
      this.eVerifyDocumentFiles = [];
      return;
    }

    this.eVerifyDocumentFiles = files;
  }

  clearEVerifyDocumentFiles(fileInput?: HTMLInputElement) {
    this.eVerifyDocumentFiles = [];
    if (fileInput) {
      fileInput.value = '';
    }
  }

  private uploadSelectedEVerifyDocument(files: File[]) {
    if (!files.length) {
      return;
    }

    if (!this.otherUploadType?.id) {
      this.alertService.error('Unable to upload the E-Verify document because the Other document type is not available.');
      return;
    }

    this.uploadingEVerifyDocument = true;
    this.store.dispatch(uploadEVerifyDocument({
      docTypeID: this.otherUploadType.id.toString(),
      files,
      userId: this.managedUserId
    }));
  }

  private hasUnsupportedWordDocument(files: File[]) {
    return files.some(file => {
      const fileName = file.name.toLowerCase();
      return fileName.endsWith('.doc') || fileName.endsWith('.docx');
    });
  }

  showNoOtherLanguages() {
    let otherLanguages = this.form.get('otherLanguages') as UntypedFormArray;
    return otherLanguages.length == 0;
  }

}

